module.exports = __webpack_public_path__ + "img/pic_title_img.7e835bcb.png";